export const skipGift = (form, showQCmodal, modalToHide) => {
    $(modalToHide).modal('hide');
    if (showQCmodal) {
        $('.quick-checkout-modal-view').modal('show');
        $('.quick-checkout-modal-view').addClass('in');        
		if($('.modal-backdrop')) $('.modal-backdrop').addClass('in');
    } else {
        form.URL.value = form.newURL.value;
        form.submit();
    }
};
